import React from 'react';

import { Transition } from 'react-transition-group';
import { ChanceElement } from './ChanceElement';

import { Container, Button, Alert, Table } from 'reactstrap';

const duration = 1000;
const delay = 2000;
const d = 500;
const opc = 1;
const opc1 = 1;
const defaultStyle = {
    transition: `opacity ${duration}ms ease-in-out`,
    opacity: 0,
}

const transitionStyles = {
    entering: { opacity: opc },
    entered: { opacity: opc },
    exiting: { opacity: opc1 },
    exited: {
        opacity: 0,
    },
};
const defaultStyle2 = {
    transition: `opacity ${duration + d}ms ease-in-out`,
    opacity: 0,
}

const transitionStyles2 = {
    entering: { opacity: opc },
    entered: { opacity: opc },
    exiting: { opacity: opc1 },
    exited: {
        opacity: 0,
    },
};
const defaultStyle3 = {
    transition: `opacity ${duration + 2 * d}ms ease-in-out`,
    opacity: 0,
}

const transitionStyles3 = {
    entering: { opacity: opc },
    entered: { opacity: opc },
    exiting: { opacity: opc1 },
    exited: {
        opacity: 0,
    },
};
const defaultStyle4 = {
    transition: `opacity ${duration + 3 * d}ms ease-in-out`,
    opacity: 0,
}

const transitionStyles4 = {
    entering: { opacity: opc },
    entered: { opacity: opc },
    exiting: { opacity: opc1 },
    exited: {
        opacity: 0,
    },
};
const defaultStyle5 = {
    transition: `opacity ${duration + 4 * d}ms ease-in-out`,
    opacity: 0,
}

const transitionStyles5 = {
    entering: { opacity: opc },
    entered: { opacity: opc },
    exiting: { opacity: opc1 },
    exited: {
        opacity: 0,
    },
};



export class DivTrain extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};

        this.state.data = this.props.Data;

        /*
                this.data = [];
                for (var i = 0; i < 37; i++) {
                    var d = {};
                    d.msg = i;
                    d.uniqueId = i;
                    d.chanceNumber = 100 + i;
                    d.mobileNumber = "09192104" + i;
                    this.data.push(d);
                }
        */
        this.data = this.props.reverseChances;
        this.reverseNum = this.props.reverseNum;

        this.showLen = 4;

        this.state.isLoaded = false;
        this.showData = [];

        for (var i = 0; i < this.showLen; i++) {
            this.showData.push(null);

        }


        this.state.firstTime = true;
        this.cursur = 0;

        this.state.active = false;
        this.handleClick = this.handleClick.bind(this);
        this.handleClick1 = this.handleClick1.bind(this);
    }

    handleClick1() {

        if (this.state.active !== true || this.state.firstTime === true) {

            this.state.firstTime = false;
            if (this.data.length === null) {

            }
            else {
                for (var i = 0; i < this.showLen; i++) {
                    this.showData[i] = null;
                }


                for (var i = 0; i < this.showLen; i++) {
                    if (i >= this.data.length)
                        break;

                    var index = (i + this.cursur) % this.data.length;
                    this.showData[i] = this.data[index];
                }
                //       console.log(this.showData);
                this.cursur = this.cursur + this.showLen;

            }
        }
        this.state.isLoaded = true;
        this.setState({ active: !this.state.active });
    }
    handleClick() {



        this.handleClick1();
        setTimeout(
            function () {
                this.handleClick();
            }
                .bind(this),
            duration + delay
        );


    }


    componentDidMount() {

        this.handleClick();

    }

    componentDidUpdate() {
  
        if (this.reverseNum != this.props.reverseNum) {


            this.cursur = 0;
            this.reverseNum = this.props.reverseNum;
            this.data = this.props.reverseChances;
            this.state.isLoaded = false;
            this.state.active = false;
            this.setState({});
            this.handleClick1();


        }
    }

    render() {

        if (this.state.isLoaded === false) {
            return <div className="container-fluid row text-center" style={{}}>
                <div className="col-md-2" >

                    <br />
                    <Table style={{ background: 'white', borderRadius: '10px' }}>

                        <tbody>



                            <tr>
                                <td style={{ color: "darkred",borderTop:'none' }}><h4>ردیف قرعه کشی</h4> </td>
                            </tr>

                            <tr>
                                <td><h4>کد قرعه کشی</h4></td>
                            </tr>

                            <tr>
                                <td><h4>شماره همراه</h4></td>
                            </tr>

                        </tbody>

                    </Table>

                </div>
            </div>
        }


        return (
            <div className="container-fluid row text-center" style={{}}>



                <div className="col-md-2" >

                    <br />
                    <Table style={{ background: 'white', borderRadius: '10px' }}>

                        <tbody>
                            <tr>
                                <td style={{ color: "darkred" }}><h4>ردیف قرعه کشی</h4> </td>
                            </tr>
                            <tr>
                                <td><h4>کد قرعه کشی</h4></td>
                            </tr>



                            <tr>
                                <td><h4>شماره همراه</h4></td>
                            </tr>

                        </tbody>

                    </Table>

                </div>
                <div className="col-md-2" style={{ overflow: "hidden", marginRight: "50px" }}>
                    <Transition in={this.state.active} timeout={duration}>
                        {state => (
                            <div style={{
                                ...defaultStyle,
                                ...transitionStyles[state]
                            }}>
                                <br />
                                <ChanceElement data={this.showData[0]} reverseNum={this.props.reverseNum} />
                            </div>
                        )}
                    </Transition>
                </div>

                <div className="col-md-2" style={{ overflow: "hidden", marginRight: "50px" }}>
                    <Transition in={this.state.active} timeout={duration}>
                        {state => (
                            <div style={{
                                ...defaultStyle2,
                                ...transitionStyles2[state]
                            }}>
                                <br />
                                <ChanceElement data={this.showData[1]} reverseNum={this.props.reverseNum} />
                            </div>
                        )}
                    </Transition>
                </div>

                <div className="col-md-2" style={{ overflow: "hidden", marginRight: "50px" }}>
                    <Transition in={this.state.active} timeout={duration}>
                        {state => (
                            <div style={{
                                ...defaultStyle3,
                                ...transitionStyles3[state]
                            }}>
                                <br />
                                <ChanceElement data={this.showData[2]} reverseNum={this.props.reverseNum} />
                            </div>
                        )}
                    </Transition>
                </div>
                <div className="col-md-2" style={{ overflow: "hidden", marginRight: "50px" }}>
                    <Transition in={this.state.active} timeout={duration}>
                        {state => (
                            <div style={{
                                ...defaultStyle4,
                                ...transitionStyles4[state]
                            }}>
                                <br />
                                <ChanceElement data={this.showData[3]} reverseNum={this.props.reverseNum} />
                            </div>
                        )}
                    </Transition>
                </div>



            </div>


        );
    }
}



// WEBPACK FOOTER //
// ./src/elements/DivTrain.js